<template>
    <div class="main-content bg-default">
        <!-- Navbar -->
        <base-nav class="navbar-top navbar-horizontal navbar-dark"
                  containerClasses="px-4 container"
                  expand>
            <router-link slot="brand" class="navbar-brand" to="/">
                <img src="img/brand/quran-clip-helper-logo.png" style="height: 60px; max-height: none;">
            </router-link>

            <template v-slot="{closeMenu}">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img src="img/brand/quran-clip-helper-logo.png" style="max-height: 40px;">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <button type="button"
                                    @click="closeMenu"
                                    class="navbar-toggler"
                                    aria-label="Toggle sidenav">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Navbar items -->
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/helper">
                            <i class="ni ni-collection"></i>
                            <span class="nav-link-inner--text">Helper</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/video-creator">
                            <i class="ni ni-camera-compact"></i>
                            <span class="nav-link-inner--text">Video Creator</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/audio-processing">
                            <i class="ni ni-headphones"></i>
                            <span class="nav-link-inner--text">Audio Processing</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" @click.native="clickModal0" to="/">
                            <i class="ni ni-planet"></i>
                            <span class="nav-link-inner--text">Contact Us</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" @click.native="clickModal1" to="/">
                            <i class="ni ni-bullet-list-67"></i>
                            <span class="nav-link-inner--text">FAQ</span>
                        </router-link>
                    </li>
                </ul>
            </template>
        </base-nav>
        
        <!-- Site Announcements Banner (below navbar) -->
        <div v-if="visibleAnnouncements.length > 0" class="announcements-container">
            <div 
                v-for="ann in visibleAnnouncements" 
                :key="ann.id" 
                :class="'announcement-banner alert alert-' + ann.type + ' mb-0 rounded-0 text-center py-2 d-flex align-items-center justify-content-center position-relative'"
                role="alert"
            >
                <span v-html="ann.message" class="flex-grow-1"></span>
                <button 
                    type="button" 
                    class="close-btn"
                    @click="dismissAnnouncement(ann.id)"
                    aria-label="Close"
                >
                    &times;
                </button>
            </div>
        </div>
        
        <!-- Header -->
        <div class="header bg-gradient-success py-7 py-lg-10">
            <div class="container">
                <div class="header-body text-center mb-5">
                    <div class="row justify-content-center">
                        <div class="col-lg-8 col-md-10">
                            <h1 class="text-white">Quran-Clip Helper</h1>
                            <p class="text-lead text-white">Asalam Alykom! This site helps you create beautiful Quran video clips with AI-powered ayah detection, stunning fonts, and customizable overlays. Use the <strong>Helper</strong> for quick access to Quranic text and translations, or try the <strong>Video Creator</strong> to generate professional videos from your recitation audio. This is a free site so please keep the developers in your duas! Help sustain this free resource with a small <a href="https://linktr.ee/moazelsayedquran" target="_blank" style="color: #ffd700; font-weight: bold;">donation</a>, jazakum Allahu khayran.</p>
                            <br>
                            <div class="text-center float-center">         
                                <a href="https://youtu.be/C_2RKeIyY-U" class="nav-link" target="_blank">Tutorial: How to use 'Helper'</a>
                                <a href="https://youtu.be/jRpZSzDj0sY" class="nav-link" target="_blank">Tutorial: How to use 'Video Creator'</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-8">
            <fade-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </fade-transition>
        </div>
        <modal :show.sync="modals.modal0" :modal="modals">
            <h2 slot="header" class="modal-title" id="modal-title-default">Contact Info</h2>

            <p>> moazelsayedquran@gmail.com</p>
            <p>> instagram.com/moazquran</p>

            <template slot="footer">
                <base-button outline type="primary" class="btn btn-neutral btn-icon px-lg-3 text-center" @click="modals.modal0 = false">Close
                </base-button>
            </template>
        </modal>
        <modal :show.sync="modals.modal1" :modal="modals">
            <h2 slot="header" class="modal-title" id="modal-title-default">Frequently Asked Questions</h2>

            <p>Note: Translations are pulled straight from an API, some translations might not be fully reviewed. If any mistakes are found please contact us immediately</p>

            <p>I found a bug, where do I report it?<br>
            <small>Please email me right away! moazelsayedquran@gmail.com</small></p>

            <p>What default english translation is being used?<br>
            <small>The translation being used is <a href="https://theclearquran.org/"> The Clear Qur'an by Dr. Mustafa Khatab</a></small></p>

            <p>What word-by-word translation is used in the Video Creator?<br>
            <small>The word-by-word translations are sourced from <a href="https://quranwbw.com" target="_blank">QuranWBW.com</a>. The English word-by-word translation was compiled by <strong>Dr. Shehnaz Shaikh</strong> and <strong>Ms. Kausar Khatri</strong> (published 2007, Public Domain). It is a composite work that draws word choices from multiple established translations including Sahih International, Abdullah Yusuf Ali, Pickthall, and others to best convey the meaning of each Arabic word individually. Word-by-word translations are available in 19 languages including English, Urdu, Hindi, Indonesian, Bangla, Turkish, and more.</small></p>

            <p>How can I use Glyphs?<br>
            <small>Please follow the <a href="https://youtu.be/C_2RKeIyY-U">instructional video here</a></small></p>
            
            <p>Where can I download Filmora?<br>
            <small>On their official <a href="https://filmora.wondershare.com/download-filmora9-windows.html">site here </a></small></p>
            
            <p>How do Glyphs differ from png image?<br>
            <small>Glyphs are symbol representations for actual fonts. These fonts are from the King Fahad Quran Complex.
                This font family needs to be downloaded and installed on your computer before you are able to use them on filmora.
                <a href="https://drive.google.com/file/d/1_LUv-Ol8a1ItJN7c-TtpSwjdchaPRc9g/view?usp=sharing">You can download the font family here </a>
            </small></p>

            <p>What arabic font is it using?<br>
            <small>Font Madani</small></p>

            <p>Can I use your API?<br>
            <small>Sure thing! just please don't bog it down --> api.qurancliphelper.com</small></p>
            
            <p>How can I request additional features to this site?<br>
            <small>Please contact me (moazelsayedquran@gmail.com) and i'll see if i'm able to add it inshaAllah.</small></p>

            <p>Join our WhatsApp Community<br>
            <small><a href="https://chat.whatsapp.com/KHkt8ZSJchfFO0GyJawQ0P" target="_blank">Click here to join our WhatsApp community</a> for updates, support, and discussions.</small></p>
            
            
            <template slot="footer">
                <base-button outline type="primary" class="btn btn-neutral btn-icon px-lg-3 text-center" @click="modals.modal1 = false">Close
                </base-button>
            </template>
        </modal>
        <footer class="py-5 bg-default">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-12 text-center">
                        <div class="footer-links mb-3">
                            <router-link to="/privacy" class="text-white mx-3">Privacy Policy</router-link>
                            <span class="text-muted">|</span>
                            <router-link to="/terms" class="text-white mx-3">Terms of Service</router-link>
                            <span class="text-muted">|</span>
                            <router-link to="/data-deletion" class="text-white mx-3">Data Deletion</router-link>
                        </div>
                        <p class="text-muted mb-0">&copy; {{ year }} Quran Clip Helper. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
  import { FadeTransition } from 'vue2-transitions'

  export default {
    name: 'auth-layout',
    components: {
      FadeTransition,
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false,
        modals:{
            modal0: false,
            modal1: false
        },
        announcements: [],
        dismissedAnnouncements: []
      }
    },
    computed: {
      visibleAnnouncements() {
        return this.announcements.filter(ann => !this.dismissedAnnouncements.includes(ann.id));
      }
    },
    mounted() {
      const dismissed = localStorage.getItem('dismissedAnnouncements');
      if (dismissed) {
        this.dismissedAnnouncements = JSON.parse(dismissed);
      }
      this.fetchAnnouncements();
    },
    methods:{
        clickModal0(e){
            e.preventDefault();
            this.modals.modal0 = true;
        },
        clickModal1(e){
            e.preventDefault();
            this.modals.modal1 = true;
        },
        async fetchAnnouncements() {
            try {
                const apiBaseUrl = window.location.hostname === 'localhost' 
                    ? 'http://localhost:8000' 
                    : '';
                const response = await this.axios.get(`${apiBaseUrl}/api/announcements`);
                this.announcements = response.data.announcements || [];
            } catch (err) {
                console.error('Error fetching announcements:', err);
            }
        },
        dismissAnnouncement(announcementId) {
            this.dismissedAnnouncements.push(announcementId);
            localStorage.setItem('dismissedAnnouncements', JSON.stringify(this.dismissedAnnouncements));
        }
    }
  }
</script>
<style scoped>
.announcements-container {
    position: relative;
    z-index: 1000;
    width: 100%;
}
.announcement-banner {
    position: relative;
}
.close-btn {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 1;
    color: inherit;
    opacity: 0.7;
    cursor: pointer;
    padding: 5px 10px;
    z-index: 1001;
}
.close-btn:hover {
    opacity: 1;
}
</style>
